import React from 'react';
import styled from 'styled-components';

type Props = {
    children: string,
}

const H6 = (props: Props) => {
    return (
        <H6WithStyled { ...props }>
            { props.children }
        </H6WithStyled>
    );
};

const H6WithStyled = styled.h6`
`

export default H6;